import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { size } from 'lodash/fp';

const S = {
  Wrapper: styled.div.attrs(({ position, rectWidth }) => ({
    style: {
      width: `${rectWidth}px`,
      transform: `translate(${position.x + 2}px, ${position.y + 2}px)`,
    },
  }))`
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    overflow: hidden;
    padding-left: 8px;
    color: ${({ theme }) => theme.palette.primary.light};
    background-color: #e5e7f0;
    font-size: ${({ theme }) => theme.typography.pxToRem(13)};
    font-weight: 500;
    line-height: 1.54;
    box-shadow: 0 1px 2px 0 rgba(93, 108, 164, 0.54);
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: none;
    ::before {
      content: '';
      position: absolute;
      bottom: 2px;
      right: 2px;
      border: 4px solid ${({ theme }) => theme.palette.primary.light};
      border-top-color: transparent;
      border-left-color: transparent;
    }
  `,
};

const RectCursorFollower = ({
  bindHover, position, questions, rectWidth,
}) => (
  <S.Wrapper position={position} rectWidth={rectWidth} {...bindHover}>
    {`${size(questions)}번 질문 답변`}
  </S.Wrapper>
);

RectCursorFollower.propTypes = {
  bindHover: PropTypes.shape({
    onMouseEnter: PropTypes.func.isRequired,
    onMouseLeave: PropTypes.func.isRequired,
  }).isRequired,
  position: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
  }).isRequired,
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      options: PropTypes.arrayOf(
        PropTypes.shape({
          number: PropTypes.number.isRequired,
          content: PropTypes.string.isRequired,
          position: PropTypes.shape({
            x: PropTypes.number.isRequired,
            y: PropTypes.number.isRequired,
          }),
        }),
      ),
    }),
  ).isRequired,
  rectWidth: PropTypes.number.isRequired,
};

export default RectCursorFollower;
